import React from 'react';

type RecordedPreviewProps = {
    url?: string;
};

const RecordedPreview: React.FC<RecordedPreviewProps> = ({ url }) => {
    return (
        <video
            src={url}
            className="w-100 h-100"
            disablePictureInPicture
            disableRemotePlayback
            autoPlay
            controls
            controlsList="nodownload nofullscreen"
            onContextMenu={(e) => e.preventDefault()}
        />
    );
};
export default React.memo(RecordedPreview);
